module.exports = __webpack_public_path__ + "img/MX-C150A-BS.fa11edc0.png";